<template>
	<div class="container">
		<el-container>
			<el-header class="header">
				<headers />
			</el-header>
			<el-container>
				<slider />
				<el-main>
					<div class="main_box">
						<div class="main_main">
							<!--Header -->
							<div class="page_header">Add Affected Article</div>
							<!--Header -->
							<div class="page_main">
								<div class="training-page">
									<el-form ref="form" :model="info" label-position="top" class="cr-form">
										<el-form-item label="CAPA ID" class="full-width-item">
											<el-input v-model="info.identifier" readonly class="gray-input"></el-input>
										</el-form-item>
										<el-form-item label="Status" class="full-width-item">
											<el-input v-model="info.status" readonly class="gray-input"></el-input>
										</el-form-item>
										<div class="text-tip">CAPA Description</div>
										<el-form-item label="Description of the issue, concern, idea, or opportunity" class="full-width-item">
											<el-input v-model="info.description" readonly class="gray-input"></el-input>
										</el-form-item>
									</el-form>
									<!-- Table Area -->
									<div class="file-panel">
										<div class="panel-header">
											<div class="panel-title">
												Items Affected by the Issue, Concern, Idea, or Opportunity
											</div>
											<el-input v-model="searchKeyword" placeholder="Search" clearable
												class="search-input">
												<i slot="prefix" class="el-input__icon el-icon-search"></i>
											</el-input>
										</div>
										<el-table :data="articleTableData" border class="file-table"
											header-cell-class-name="table-header-cell" empty-text="No affected articles">
											<el-table-column prop="" label="Item Type" min-width="130" sortable>
												<template #default="scope">
													<div v-if="scope.row.article_type == 1">Document</div>
													<div v-if="scope.row.article_type == 2">Equipment</div>
													<div v-if="scope.row.article_type == 3">Product</div>
													<div v-if="scope.row.article_type == 4">Tool</div>
													<div v-if="scope.row.article_type == 5">Other</div>
												</template>
											</el-table-column>
											<el-table-column prop="article_id" label="Item ID" min-width="110" sortable />
											<el-table-column prop="article_name" label="Item Name" min-width="130" sortable />
											<el-table-column prop="article_revision" label="Item Revision" min-width="140" sortable></el-table-column>
											<el-table-column prop="" label="Product Serial Number" min-width="200" sortable>
												<template #default="scope">
													{{ scope.row.serial_number || 'N/A' }}
												</template>
											</el-table-column>
											<el-table-column prop="" label="Product Batch Number" min-width="180" sortable>
												<template #default="scope">
													{{ scope.row.lot_number || 'N/A' }}
												</template>
											</el-table-column>
											<el-table-column prop="" label="Purchased Product?" min-width="180" sortable>
												<template #default="scope">
													<div v-if="scope.row.is_buy == 1">Yes</div>
													<div v-if="scope.row.is_buy == 2">No</div>
													<div v-else></div>
												</template>
											</el-table-column>
											<el-table-column prop="" label="Product Supplier" min-width="180" sortable>
												<template #default="scope">
													{{ scope.row.supplier_name || '' }}
												</template>
											</el-table-column>
										</el-table>
									</div>
									<div class="affected-article-page">
										<!-- Top Description -->
										<div class="tips-box">
											<div class="tips-title">
												Identify items affected by the issue, concern, idea, or opportunity.
											</div>
											<div class="tips-desc">
												●
												For example, if you are reporting a product issue, select 'Product' as the affected item type, enter the product number in 'Affected Item ID', and enter the product name in 'Affected Item Name'.
											</div>
										</div>
										<el-form ref="formRef" :model="form" :rules="rules" label-position="top" class="article-form">
											<el-form-item label="Affected Item Type" prop="articleType" required>
												<el-select v-model="form.articleType" placeholder="Please select" class="full-width"
													clearable>
													<el-option label="Document" value="1" />
													<el-option label="Equipment" value="2" />
													<el-option label="Product" value="3" />
													<el-option label="Tool" value="4" />
													<el-option label="Other" value="5" />
												</el-select>
											</el-form-item>
											<el-form-item label="Affected Item ID" prop="articleId" required>
												<el-input v-model="form.articleId" placeholder="Please enter" />
											</el-form-item>
											<el-form-item label="Affected Item Name" prop="productName" required>
												<el-input v-model="form.productName" placeholder="Please enter" />
											</el-form-item>
											<el-form-item label="Affected Item Revision" prop="articleRevision" required>
												<el-input v-model="form.articleRevision" placeholder="Please enter" />
											</el-form-item>
											<!-- Middle Description -->
											<div v-if="form.articleType == 3" class="tips-box second-tips">
												If the identified item is a product, provide as much detail as possible. If this field is not applicable, enter 'N/A”。
											</div>
											<el-form-item v-if="form.articleType == 3" prop="serialNumber" label="Affected Product Serial Number" required>
												<el-input v-model="form.serialNumber" placeholder="Please enter" />
											</el-form-item>
											<el-form-item v-if="form.articleType == 3" prop="lotNumber" label="Affected Product Batch Number" required>
												<el-input v-model="form.lotNumber" placeholder="Please enter" />
											</el-form-item>
											<el-form-item  v-if="form.articleType == 3" prop="isPurchased" label="Is this a purchased product??" required>
												<el-select v-model="form.isPurchased" class="full-width" placeholder="Please select">
													<el-option label="Yes" value="1" />
													<el-option label="No" value="2" />
												</el-select>
											</el-form-item>
											<el-form-item v-if="form.articleType == 3" label="Affected Product Supplier" prop="supplier" required>
												<div class="supplier-row">
													<el-select filterable v-model="form.supplier" placeholder="Please select"
														class="full-width" clearable>
														<el-option v-for="value in supplierList" :key="value.id"
															:label="value.title" :value="value.id"></el-option>
													</el-select>
												</div>
											</el-form-item>
										</el-form>
									</div>
									<div class="footer-btn">
										<el-button type="primary" @click="handleSave('formRef')">Save</el-button>
										<el-button type="primary" @click="handleClose">Close</el-button>
									</div>
								</div>
							</div>
						</div>
					</div>
				</el-main>
			</el-container>
		</el-container>
		<!--loading-->
		<transition name="fade">
			<div class="loading" v-show="isLoading">
				<van-loading />
			</div>
		</transition>
		<!--loading-->
	</div>
</template>

<script>
import {
	capaUploadsCapaAffectedArticle,
	capaUploadsCapaAffectedArticleDel
} from "@/api/capaManage/capaRequest/index";
import { resourcesApplyDetail } from "@/api/docManage/changeRequest/index";
import { suplierList } from '@/api/capaManage/configCapa/capaManageSuppliers/index';
import headers from "@/component/header.vue";
import slider from "@/component/slider.vue";
export default {
	components: {
		headers,
		slider,
	},
	data() {
		return {
			isLoading: true,
			id: "",
			info: {
				id: null,
				identifier: "",
				status: "",
				description: "",
			},
			searchKeyword: "",
			tableData: [],
			supplierList: [],
			form: {
				articleType: "",
				articleId: "",
				productName: "",
				articleRevision: "",
				serialNumber: "",
				lotNumber: "",
				isPurchased: "",
				supplier: "",
			},

			rules: {
				articleType: [{
					required: true,
					message: "Please select the affected item type",
					trigger: "change",
				}, ],
				articleId: [{
					required: true,
					message: "Please enter the affected item ID",
					trigger: "blur"
				}, ],
				productName: [{
					required: true,
					message: "Please enter the affected product name",
					trigger: "blur",
				}, ],
				articleRevision: [{
					required: true,
					message: "Please enter the affected item revision",
					trigger: "blur",
				}, ],
				serialNumber: [{
					required: true,
					message: "Please enter the affected product serial number",
					trigger: "blur",
				}, ],
				lotNumber: [{
					required: true,
					message: "Please enter the affected product batch number",
					trigger: "blur",
				}, ],
				isPurchased: [{
					required: true,
					message: "Please select whether this is a purchased product?",
					trigger: "change",
				}, ],
				supplier: [{
					required: true,
					message: "Please select the affected product supplier",
					trigger: "change",
				}, ],
			},
		};
	},
	created() {
		let that = this;
		that.id = that.$route.query.oid;
	},
	mounted() {
		let that = this;
		//Request supplier
		suplierList({ title: '', page: 1, page_size: 9999 }).then(res => {
			if(res.code == 200) {
				that.supplierList = res.data;
			}
		});
		//Request Details
		that.getPageInfo();
		that.isLoading = false;
	},
	computed: {
		articleTableData() {
			return this.filterTableData(this.tableData, this.searchKeyword);
		},
	},
	methods: {
		//Request Details
		getPageInfo() {
			let that = this;
			resourcesApplyDetail({ id: that.id }).then(res => {
				if(res.code == 200) {
					that.info.id = res.data.id;
					if(res.data.step < 3) {
						that.info.identifier = 'New Request' + '（'+res.data.request_id+'）';
					}else {
						that.info.identifier = res.data.request_id;
					}
					that.info.status = res.data.status_name;
					that.info.description = res.data.description;
					that.tableData = res.data.capaarticle_list;
				}
			});
		},
		filterTableData(source, keyword) {
			if (!keyword || !keyword.trim()) return source;
			const lowerKeyword = keyword.toLowerCase().trim();
			return source.filter((item) => {
				const text = this.flattenValues(item).toLowerCase();
				return text.includes(lowerKeyword);
			});
		},
		flattenValues(data) {
			if (data === null || data === undefined) return "";
			if (Array.isArray(data)) {
				return data.map((item) => this.flattenValues(item)).join(" ");
			}
			if (typeof data === "object") {
				return Object.values(data)
					.map((val) => this.flattenValues(val))
					.join(" ");
			}
			return String(data);
		},
		handleSave(formName) {
			let that = this;
			that.$refs[formName].validate((valid) => {
				if (!valid) return;
				//Upload Affected Articles
				that.$toast.loading({ duration: 0, forbidClick: true });
				capaUploadsCapaAffectedArticle({
					id: '',
					capa_id: that.info.id,
					article_type: that.form.articleType,
					article_id: that.form.articleId,
					article_name: that.form.productName,
					article_revision: that.form.articleRevision,
					serial_number: that.form.articleType == 3 ? that.form.serialNumber : 'N/A',
					lot_number:  that.form.articleType == 3 ? that.form.lotNumber : 'N/A',
					is_buy:  that.form.articleType == 3 ? that.form.isPurchased : '',
					supplier_id:  that.form.articleType == 3 ? that.form.supplier : ''
				}).then(res => {
					if(res.code == 200) {
						that.$toast.clear();
						that.$message.success("Operation successful");
						setTimeout(() => {
							window.location.reload();
						}, 800);
					}
				});
			});
		},
		handleClose() {
			let that = this;
			that.$router.back();
		},
	},
};
</script>

<style lang="less" scoped>
	//Main Content
	.main_main {
		.page_main {
			padding: 18px 20px;

			.btn_el {
				margin: 10px 0 20px 0;

				.tips {
					padding: 6px 8px;
					background-color: #ffb1001a;
					border-radius: 6px;
					font-size: 16px;
					font-weight: bold;
				}
			}
		}

		//Header
		.page_header {
			padding: 0 20px;
			height: 60px;
			line-height: 60px;
			background-color: #d8e4f0;
			font-size: 24px;
			font-weight: bold;
			box-shadow: 0 2px 4px rgba(0, 0, 0, 0.075);
		}
	}
</style>
<style scoped>
	.main_box {
		height: calc(100vh - 60px);
		overflow-y: auto;
	}

	.main_box .main_main {
		position: relative;
		min-height: calc(100% - 0px);
		max-height: auto;
		background-color: #fafafa;
	}

	.el-header,
	.el-main {
		padding: 0;
	}

	.training-page {
		padding: 12px;
		box-sizing: border-box;
	}

	.full-width-item {
		margin-top: 8px;
	}

	/* Unified input style */
	.gray-input ::v-deep .el-input__inner {
		background: #e9ecef;
		border: 1px solid #cfd5db;
		color: #2f343b;
		border-radius: 8px;
		height: 40px;
		line-height: 40px;
		font-size: 14px;
	}

	.gray-input ::v-deep .el-textarea__inner {
		background: #e9ecef;
		border: 1px solid #cfd5db;
		color: #2f343b;
		border-radius: 8px;
		font-size: 14px;
	}

	.text-tip {
		background-color: #fafafa;
		font-size: 24px;
		font-weight: bold;
		margin-bottom: 20px;
	}

	.file-panel {
		background: #fff;
		border: 1px solid #dcdfe6;
		margin-top: 40px;
	}

	.panel-header {
		display: flex;
		justify-content: space-between;
		align-items: center;
		padding: 12px 16px;
	}

	.panel-title {
		font-size: 18px;
		font-weight: 700;
		color: #222;
		line-height: 32px;
	}

	.search-input {
		width: 220px;
	}

	.file-table {
		width: 100%;
		margin-top: 8px;
	}

	.affected-article-page {
		width: 100%;
		padding: 12px 15px;
		box-sizing: border-box;
		background: #fff;
	}

	.tips-box {
		width: 100%;
		padding: 10px 8px;
		box-sizing: border-box;
		background: #fff6e8;
		border-radius: 4px;
		color: #222;
		font-size: 14px;
		line-height: 22px;
		margin-bottom: 18px;
	}

	.tips-title {
		font-weight: 700;
	}

	.tips-desc {
		margin-top: 2px;
		font-weight: 600;
	}

	.second-tips {
		margin-top: 20px;
		margin-bottom: 18px;
		font-weight: 700;
	}

	.article-form {
		width: 100%;
	}

	.full-width {
		width: 100%;
	}

	.supplier-row {
		display: flex;
		width: 100%;
	}

	.supplier-row .el-input {
		flex: 1;
	}

	.choose-btn {
		width: 64px;
		padding-left: 0;
		padding-right: 0;
		border-radius: 0 4px 4px 0;
	}

	::v-deep .el-form-item {
		padding-bottom: 5px;
	}

	::v-deep .el-form-item__label {
		padding-bottom: 6px;
		line-height: 18px;
		font-size: 13px;
		color: #333;
		font-weight: 700;
	}

	::v-deep .el-form-item.is-required:not(.is-no-asterisk)>.el-form-item__label:after {
		content: "*";
		color: #f56c6c;
		margin-left: 3px;
	}

	::v-deep .el-form-item.is-required:not(.is-no-asterisk)>.el-form-item__label:before {
		display: none;
	}

	::v-deep .el-input__inner {
		height: 33px;
		line-height: 33px;
		border-radius: 4px;
		border-color: #bfc4cc;
		font-size: 14px;
	}

	::v-deep .el-input.is-disabled .el-input__inner {
		background-color: #e9edf2;
		border-color: #c7ccd3;
		color: #666;
		cursor: not-allowed;
	}

	::v-deep .el-select .el-input .el-select__caret {
		color: #333;
	}

	::v-deep .supplier-row .el-input__inner {
		border-radius: 4px 0 0 4px;
	}

	.footer-btn {
		width: 100%;
		display: flex;
		justify-content: center;
		align-items: center;
		margin-top: 50px;
	}

	::v-deep .el-form-item__label {
		padding-bottom: 8px;
		font-size: 14px;
		line-height: 20px;
		color: #2f343b;
		font-weight: 700;
	}
</style>